import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useLenis from "../hooks/useLenis";
import Nav from "./Nav";
import Footer from "./Footer";
import StickyContactBar from "./StickyContactBar";

export default function Layout({ children }) {
  useLenis();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="App bg-bg text-ink min-h-screen flex flex-col" data-testid="app-shell">
      <Nav />
      <main className="flex-1 pb-20 md:pb-24" data-testid="main-content">
        {children}
      </main>
      <Footer />
      <StickyContactBar />
    </div>
  );
}
